// React
import { createContext, useContext, useMemo, useState } from "react";
import PropTypes from "prop-types";

// Redux
import { useSelector } from "react-redux";

// Custom Hooks
import { useMotivatorsQueriesModel } from "./MotivatorsQueriesModel";

export const MotivatorsContext = createContext({ setTitle: (_title) => {} });

function MotivatorsProvider({ children, motivatorType, setTitle }) {
	const location = useSelector((state) => state.location.location);
	const locationId = location?.locationId;

	// State
	const [selection, setSelection] = useState(null);
	const [isLoading, setIsLoading] = useState(false);
	const [selectNewlyCreated, setSelectNewlyCreated] = useState(false);

	const { actions, queries, mutations, subscriptions, identifiers, helpers } = useMotivatorsQueriesModel(motivatorType);

	const store = useMemo(
		() => ({
			setTitle,
			locationId,
			motivatorType,
			actions,
			queries,
			mutations,
			subscriptions,
			identifiers,
			helpers,
			selection,
			setSelection,
			isLoading,
			setIsLoading,
			selectNewlyCreated,
			setSelectNewlyCreated,
		}),
		[
			setTitle,
			motivatorType,
			actions,
			queries,
			identifiers,
			mutations,
			subscriptions,
			helpers,
			selection,
			setSelection,
			isLoading,
			setIsLoading,
			locationId,
			selectNewlyCreated,
			setSelectNewlyCreated,
		]
	);

	return <MotivatorsContext.Provider value={store}>{children}</MotivatorsContext.Provider>;
}

function useMotivators() {
	const context = useContext(MotivatorsContext);
	if (!context) {
		throw new Error("useMotivators must be used within a MotivatorsProvider");
	}
	return context;
}

MotivatorsProvider.propTypes = {
	children: PropTypes.node.isRequired,
	motivatorType: PropTypes.string.isRequired,
	setTitle: PropTypes.func,
};

export { MotivatorsProvider, useMotivators };
